import { FUEL } from '../config/tuning';

export interface FuelInput {
  /** Throttle intent in [-1, 1]: positive drives, negative brakes or reverses. */
  throttle: number;
  /** Signed forward speed along the route (m/s). */
  forwardSpeed: number;
}

/** Fuel after one fixed tick. Arithmetic only, so it is deterministic across platforms. */
export interface FuelSpec {
  capacity: number;
  drainIdle: number;
  drainThrottle: number;
}

const STOCK: FuelSpec = { capacity: FUEL.capacity, drainIdle: FUEL.drainIdle, drainThrottle: FUEL.drainThrottle };

export function stepFuel(fuel: number, input: FuelInput, dt: number, spec: FuelSpec = STOCK): number {
  const throttle = input.throttle;
  let next = fuel - spec.drainIdle * dt;
  if (throttle > 0) next -= spec.drainThrottle * throttle * dt;
  else if (throttle < 0 && input.forwardSpeed <= 0) next -= spec.drainThrottle * -throttle * 0.5 * dt; // reversing
  return Math.min(spec.capacity, Math.max(0, next));
}

/** Tracks the stall timer that ends a run when the tank is empty. */
export class StallTimer {
  private seconds = 0;

  update(fuel: number, speed: number, dt: number): boolean {
    if (fuel <= 0 && Math.abs(speed) < FUEL.stallSpeed) this.seconds += dt;
    else this.seconds = 0;
    return this.seconds >= FUEL.stallSeconds;
  }

  reset(): void {
    this.seconds = 0;
  }
}
